// Firebase Cloud Messaging Configuration File.
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Swal from "sweetalert2";

const firebaseConfig = {
  apiKey: "AIzaSyD5dCkpAvTiccPMtEnhjmZpoxi7XTJFRwQ",
  authDomain: "quiz-survey-481eb.firebaseapp.com",
  projectId: "quiz-survey-481eb",
  storageBucket: "quiz-survey-481eb.firebasestorage.app",
  messagingSenderId: "410485720794",
  appId: "1:410485720794:web:1a2c156aa2b1ce810d47e3",
  measurementId: "G-LZH9DPJLTC",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Check if browser supports service workers and push notifications
const isPushNotificationSupported = () => {
  return "serviceWorker" in navigator && "PushManager" in window;
};

// Get the current notification permission status
const getNotificationPermission = () => {
  if (!("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
};
// In firebase.js, update requestForToken function
export const requestForToken = async () => {
  try {
    console.log("=== FCM DEBUG START ===");
    console.log("User Agent:", navigator.userAgent);
    console.log("Is Edge:", /Edg/.test(navigator.userAgent));
    console.log("Service Worker support:", "serviceWorker" in navigator);
    console.log("Push Manager support:", "PushManager" in window);
    console.log("Notification support:", "Notification" in window);

    if ("Notification" in window) {
      console.log("Current Notification permission:", Notification.permission);
    }

    const currentPermission = getNotificationPermission();
    console.log("Permission status:", currentPermission);

    // **CASE 1: Permission already GRANTED**
    if (currentPermission === "granted") {
      console.log("Permission already granted, getting FCM token...");
      const token = await generateFCMToken();
      console.log("=== FCM DEBUG END ===");
      return token;
    }

    // **CASE 2: Permission DENIED**
    if (currentPermission === "denied") {
      console.warn("Notification permission was previously denied by browser");

      // Show instructions to user on how to manually enable
      const { value: action } = await Swal.fire({
        title: "Notifications Blocked",
        html: `
          <div style="text-align: left; width: 100%; ">
            <p>Your browser has blocked notifications from this site.</p>
            <p>You can manually enable them:</p>
            <ol style="display: flex; flex-direction: column; align-items: flex-start; margin-left: 16px; margin-top: 0px; padding-left: 16px;">
              <li>Click the <strong>lock icon "i" </strong> in address bar</li>
              <li>Find "Notifications" in the permissions list</li>
              <li>Change from "Block" to "Allow"</li>
              <li>Refresh this page after changing</li>
            </ol>
            <p><small>Or you can continue without notifications.</small></p>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "I'll Enable Later",
        showDenyButton: true,
        denyButtonText: "Skip Notifications",
      });

      console.log("=== FCM DEBUG END ===");
      return null; // Return null since permission is denied
    }

    // **CASE 3: Permission DEFAULT (not asked yet)**
    if (currentPermission === "default") {
      console.log("Requesting permission from user...");

      // Ask user if they want notifications
      const { isConfirmed } = await Swal.fire({
        title: "Enable Notifications?",
        html: `
          <div style="text-align: left; margin:6px 0;">
            <p style="margin: 0px;">Get notified about:</p>
            <ul style="margin-left: 20px; margin-bottom: 6px;">
              <li>Important system updates</li>
              <li>New messages and alerts</li>
              <li>Real-time notifications</li>
            </ul>
            <p><strong>After clicking "Allow", It will ask for permission.</strong></p>
          </div>
        `,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Allow Notifications",
        cancelButtonText: "Not Now",
        allowOutsideClick: false,
        backdrop: true,
      });

      if (!isConfirmed) {
        console.log("User declined notification prompt");
        return null;
      }

      // Now request browser permission
      console.log("User confirmed, requesting browser permission...");

      // Small delay to ensure Swal is closed
      await new Promise((resolve) => setTimeout(resolve, 500));

      const permission = await Notification.requestPermission();
      console.log("Browser permission result:", permission);

      if (permission === "granted") {
        const token = await generateFCMToken();
        console.log("=== FCM DEBUG END ===");
        return token;
      } else if (permission === "denied") {
        // Edge silently denied (quiet UI)
        console.warn("Browser silently denied permission");

        await Swal.fire({
          title: "Permission Not Granted",
          text: "Browser blocked the notification request. You can enable notifications in browser settings later.",
          icon: "info",
          timer: 3000,
        });

        return null;
      } else {
        // Permission is still "default" (user closed prompt)
        console.log("User closed the permission prompt");
        return null;
      }
    }

    // **CASE 4: Unsupported browser**
    console.warn("Notifications not supported in this browser");
    console.log("=== FCM DEBUG END ===");
    return null;
  } catch (error) {
    console.error("Failed to get FCM token:", error);
    return null;
  }
};

// Helper function to generate FCM token
const generateFCMToken = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey:
        "BOj4-vyVNnq8MC-2ldR3N3U8GAMoPU0Gd8-UccDmEUSvW_R-ngjoTtwcDAf7mh7w-wFTxMN_dE_RPSHYmDtqO8Y",
      serviceWorkerRegistration: registration,
    });

    if (!token) {
      console.warn(
        "No registration token available. Request permission to generate one.",
      );
      return null;
    }

    console.log("FCM TOKEN:", token);
    return token;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};

// Handle incoming messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// Optional: Add a function to check and request permission manually
export const checkAndRequestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.warn("This browser does not support desktop notification");
    return "unsupported";
  }

  if (Notification.permission === "granted") {
    return "granted";
  }

  if (Notification.permission === "denied") {
    console.warn("User has blocked notifications");
    return "denied";
  }

  // Permission is 'default' - ask the user
  try {
    const permission = await Notification.requestPermission();
    return permission;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return "error";
  }
};
